import React from "react";
import { CheckCircleIcon } from "@heroicons/react/24/outline";

const MeetingArrivedOverlay = ({ distance, onEnd }) => {
  return (
    <div className="fixed inset-0 z-[2000] overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 bg-black bg-opacity-60 transition-opacity backdrop-blur-sm"></div>

        <div className="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-2xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full">
          <div className="bg-gradient-to-r from-green-500 to-green-600 px-6 py-8 text-center">
            <div className="w-20 h-20 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
              <CheckCircleIcon className="h-10 w-10 text-white" />
            </div>
            <h3 className="text-xl font-semibold text-white mb-1">
              You have arrived!
            </h3>
            <p className="text-green-100 text-sm">
              {distance !== null
                ? `You are within ${distance} meters of the other user`
                : "You are within 20 meters of the other user"}
            </p>
          </div>

          <div className="p-6">
            <p className="text-gray-600 text-sm mb-4 text-center">
              Ready to wrap up the meeting?
            </p>
            <button
              onClick={onEnd}
              className="w-full bg-green-600 hover:bg-green-700 text-white font-medium py-3 px-4 rounded-md transition-colors"
            >
              End Meeting
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeetingArrivedOverlay;
